import { createSlice } from "@reduxjs/toolkit";
import { localMenu } from "../../data";

// The menu ships with the app, so there is nothing to load and no request to
// make — the categories are available on the very first render.
const initialState = {
    products: localMenu,
};

const productsSlice = createSlice({
    name: "products",
    initialState,
    reducers: {},
});

export default productsSlice.reducer;

export const selectAllProducts = (state) => state.products.products;
